import Vue from 'vue'

const $els = []
const $bindings = []

function bind() {
  window.addEventListener('orientationchange', refreshViewport)
  window.addEventListener('resize', refreshViewport)
}

function refreshViewport() {
  const els = Array.from($els)
  if (!els || !els.length) {
    return
  }
  els.forEach((el, index) => {
    if ($bindings[index].arg === 'min') {
      el.style.minHeight = window.innerHeight + 'px'
    } else {
      el.style.height = window.innerHeight + 'px'
    }
    el.style.width = window.innerWidth + 'px'
  })
}

Vue.directive('viewport', {
  bind(el, binding) {
    $els.push(el)
    $bindings.push(binding)
    refreshViewport()
    bind()
  },
  unbind(el, binding) {
    const index = $els.indexOf(el)
    $els.splice(index, 1)
    $bindings.splice(index, 1)
  }
})
